import { render, staticRenderFns } from "./Card6.vue?vue&type=template&id=fde723cc&"
import script from "./Card6.vue?vue&type=script&lang=js&"
export * from "./Card6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports